module.exports = __webpack_public_path__ + "img/credential8.6debc806.png";